<template>
  <BaseSvg
    :class="direction"
    :view-box.camel="viewBox"
    :title="title"
    :desc="desc"
    class="BaseArrow"
  >
    <!-- eslint-disable-next-line max-len -->
    <path d="M29.448 0L0 29.587l65.105 65.412L0 160.412 29.448 190l65.104-65.413L124 94.999 94.552 65.413 29.448 0z"/>
  </BaseSvg>
</template>

<script>
  import svg from '@/mixins/svg';

  export default {
    mixins: [svg],
    props: {
      direction: {
        type: String,
        required: true,
        validator: direction => ['up', 'right', 'down', 'left'].includes(direction),
      },
    },
    computed: {
      viewBox() {
        return ['up', 'down'].includes(this.direction) ? '0 0 190 124' : '0 0 124 190';
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .BaseArrow {
    // transform-origin: center;
  }

  .up {
    // transform: rotate(270deg);
  }

  .left {
    transform: scale(-1);
  }

  .down {
    // transform: rotate(90deg);
  }
</style>
